import { render, staticRenderFns } from "./ResearchPane.vue?vue&type=template&id=841d33ec&"
import script from "./ResearchPane.vue?vue&type=script&lang=js&"
export * from "./ResearchPane.vue?vue&type=script&lang=js&"
import style0 from "./ResearchPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports